/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
} from 'antd';
import styles from './styles.module.scss';
import styled from 'styled-components';
import axiosInstance from '../../../../axios_instance';
import { errorHandling } from '../../../../utils/helper';
import ModalCloseIcon from '../../../general/icon';

const formRules: object[] = [
  {
    required: true,
    message: 'Please input category name!',
  },
  ({ getFieldValue }: any) => ({
    validator(_: any, value: any) {
      if (!value || value.length <= 100) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error('Ensure the value has at most 100 characters.')
      );
    },
  }),
];

const StyledModal = styled(Modal)`
  background-color: #303843;
  font-size: 32px;
  color: white;
  padding: 0px;
  border-radius: 4px;
  .ant-modal-close {
    position: absolute;
    top: 40px;
    right: 60px;
  }
  div {
    color: white;
  }
  .ant-modal-content {
    background-color: #303843;
    padding: 30px;
    height: 300px;
  }
  .ant-modal-title {
    color: white;
    margin-left: 20px;
    font-size: 30px;
  }
  .ant-modal-header {
    background-color: #303843;
  }
  .anticon {
    color: white;
  }
  .ant-btn-primary {
    height: 40px;
    width: 80px;
    background: #f7931e;
    border-radius: 4px;
    margin-right: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    right: 30px;
    margin-bottom: 20px;
    color: #ffffff;
    border: none;
  }
  .ant-btn-primary:hover, .ant-btn-primary:focus {
    background: #ffa940 !important;
  }
  .ant-btn-primary:disabled {
    height: 40px;
    width: 70px;
    background: #79808a;
    border-radius: 4px;
    margin-right: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    right: 0px;
    margin-bottom: 20px;
    color: #9e9e9e;
  }
  .ant-btn-default {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    height: 40px;
    width: 80px;
    box-shadow: -2px 10px 30px rgba(0, 0, 0, 0.25);
    background: #303843;
    border-radius: 4px;
    position: absolute;
    bottom: 0px;
    right: 140px;
    margin-bottom: 20px;
  }
`;

const StyledInput = styled(Input)`
  background-color: #59606a !important;
  border: #59606a;
  height: 43px;
  color: #d5d5d5 !important;
`;

interface SkillCategoryAddModalProps {
  isModalOpen: boolean;
  setIsModalOpen: any;
}

const SkillCategoryAddModal: React.FC<SkillCategoryAddModalProps> = ({
  isModalOpen,
  setIsModalOpen,
}: SkillCategoryAddModalProps) => {
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [form] = Form.useForm();

  const addCategory = (values: any) => {
    axiosInstance
      .post('/api/v1/admin/skills/categories', values)
      .then((response) => {
        message.success(`Category created successfully`);
        setIsModalOpen(false);
        window.location.reload();
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      });
  };

  return (
    <>
      <StyledModal
        okText="Create"
        cancelText="Cancel"
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              addCategory(values);
              form.resetFields();
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
        maskClosable={false}
        centered
        destroyOnClose={true}
        title={
          <>
            Add Category
            <p className={styles['sub-title']}>Add a new skill category here</p>
          </>
        }
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        width="50%"
        closeIcon={
          <>
            <ModalCloseIcon />
          </>
        }
      >
        <Form
          form={form}
          layout="vertical"
          name="category_form_in_modal"
        >
          <Row className={styles['row']}>
            <Col span={24} className={styles['col']}>
              <p className={styles['label']}>Category Name</p>
              <Form.Item name="name" rules={formRules}>
                <StyledInput
                  style={{
                    borderBottom:
                      'name' in errorMessage ? '1px solid red' : '',
                  }}
                />
              </Form.Item>
              <p style={{ color: 'red' }}>
                {'name' in errorMessage ? errorMessage['name'] : ''}
              </p>
            </Col>
          </Row>
        </Form>
      </StyledModal>
    </>
  );
};

export default SkillCategoryAddModal;
